<div siriusAnchor [id]="anchor"></div>
<sirius-grid>
    @if (title || textHtml) {
        <div class="sir-form-feature-intro">
            <sirius-heading [text]="title" textStyleCategory="title" textStyleSize="xl"></sirius-heading>
            <sirius-text-html-paragraph [html]="textHtml" textStyleSize="l"></sirius-text-html-paragraph>
        </div>
    }
    <div class="sir-form-feature-form" [class.has-panel]="hasPanel()" [class.is-light]="hasPanel()">
        <ng-content></ng-content>
    </div>
</sirius-grid>
